import { render, staticRenderFns } from "./PlatformStats.vue?vue&type=template&id=47a51ba8&scoped=true"
import script from "./PlatformStats.vue?vue&type=script&lang=js"
export * from "./PlatformStats.vue?vue&type=script&lang=js"
import style0 from "./PlatformStats.vue?vue&type=style&index=0&id=47a51ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a51ba8",
  null
  
)

export default component.exports